import Vue from 'vue'
import VueRouter from 'vue-router'
import List from '@/page/list.vue'
import GameDetail from "@/page/GameDetail.vue";

// 确保VueRouter被正确安装
Vue.use(VueRouter)

// 定义路由时，每个路由对象中的meta必须小写且正确拼写
const routes = [
    {
        path: '/',
        name: 'list',
        component: List,
        meta: {  // 必须是meta，不能是mate/Metadata等
            title: '爆率查询'  // 明确设置标题值
        }
    },
    {
        path: '/detail',
        name: 'detail',
        component: GameDetail,
        meta: {  // 此处之前拼写错误为mate，已修正
            title: '爆率查询 - {versionName}'
        },
        props: route => ({ c_id: route.query.c_id })
    }
]

// 实例化路由
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,  // 使用环境变量的基础路径，避免路径问题
    routes
})

// 全局路由守卫：打印路由信息用于调试
router.beforeEach((to, from, next) => {
    next();
})

export default router
